import { useState } from "react";
import { X } from "lucide-react";

const AnnouncementBar = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-[hsl(var(--pastel-lavender))] text-foreground text-center py-2.5 px-4 z-[70] relative">
      <p className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.2em]">
        EARLY ACCESS — LIMITED DROP — JOIN THE WAITLIST
      </p>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-background/50 hover:text-background transition-colors sm:hidden"
        aria-label="Dismiss announcement"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
